var Marionette = require('backbone.marionette');
var DocumentTypeFormView = require('./document-type-form');
var DocumentTypesTableView = require('./document-types-table');
var DocumentTypesCollection = require('../../collections/document-types-collection');
var EntitiesCollection = require('../../collections/entities-collection');

var Radio = require('backbone.radio');

var notificationsChannel = Radio.channel('notifications');

var DocTypesView = Marionette.View.extend({
    template: require('../../templates/document-types/document-types-view.html'),

    regions: {
        documentTypes: '#document-types',
        documentTypeForm: '#document-type-form'
    },

    ui: {
    },

    events: {
    },

    childViewEvents: {
        'on:new': 'onNewDocumentType',
        'on:cancel': 'onCancel',
        'on:save': 'onSave',
        'on:update': 'onUpdate',
        'on:delete': 'onDelete'
    },

    initialize: function (options) {
        var that = this;
        _.bindAll(this, 'renderDocTypes', 'renderDocTypeFrom', 'onNewDocumentType', 'onCancel', 'onSave', 'getOrgName', 'onUpdate', 'onDelete');
        that.organizationCollection = new EntitiesCollection([], {params: [{key: 'type', value: 'organization'}]});
        that.collection = new DocumentTypesCollection();
        that.organizationCollection.fetch({success: function() {
            that.collection.fetch({success: that.renderDocTypes});
        }});
    },

    onRender: function () {
        window.document.title = "Document types";
        //this.renderDocTypes();
    },

    renderDocTypes: function() {
        this.showChildView('documentTypes', new DocumentTypesTableView({collection: this.collection, getOrgName: this.getOrgName}));
    },

    renderDocTypeFrom: function(mode, model) {
        this.showChildView('documentTypeForm', new DocumentTypeFormView({mode: mode,
            organizationCollection: this.organizationCollection, model: model}));
    },

    getOrgName: function(id) {
        if (id == undefined || id == '')
            return '';
        var that = this;
        var found = that.organizationCollection.findWhere({id: id});
        return found.attributes.name;
    },

    onNewDocumentType: function() {
        this.renderDocTypeFrom('add');
    },

    onCancel: function() {
        this.detachChildView('documentTypeForm');
        this.getChildView('documentTypes').showButton();
    },

    onSave: function() {
        this.collection.fetch();
        this.getChildView('documentTypes').render();
        this.onCancel();
    },

    onUpdate: function(model) {
        this.renderDocTypeFrom('edit', model);
    },

    onDelete: function(model) {
        var that = this;
        model.destroy({
            success: function() {
                that.collection.fetch();
            }
        });
    }
});

module.exports = DocTypesView;


//////////////////
// WEBPACK FOOTER
// ./app/views/document-types/document-types-view.js
// module id = 453
// module chunks = 0